export const environment = {
  production: false,
  azureConfig: {
    redirectUri: 'https://adm-ambientes-dev.apps.ambientesbc.com/',
    clientId: '344d8c7e-19e6-4d32-9670-fb162e83e7d5',
    tenantId: '428f4e2e-13bf-4884-b364-02ef9af41a1d',
    loginMicrosoft: 'https://login.microsoftonline.com',
    appScope: `api://344d8c7e-19e6-4d32-9670-fb162e83e7d5/default`,
    sendTokenTo: {
      'https://ingenieriati-ext-dev.apps.ambientesbc.com': [
        `api://344d8c7e-19e6-4d32-9670-fb162e83e7d5/default`,
      ],
    },
  },
  config: {
    endpoints: {
      BOK: 'https://ingenieriati-ext-dev.apps.ambientesbc.com/admin-de-ambientes-mig/apibooking',
      SFM: 'https://ingenieriati-ext-dev.apps.ambientesbc.com/admin-de-ambientes-mig/apiselfmanagement',
      TGI: 'https://ingenieriati-ext-dev.apps.ambientesbc.com/admin-de-ambientes-mig/appincident',
      ADA: 'https://ingenieriati-ext-dev.apps.ambientesbc.com/admin-de-ambientes-mig',
      CONCURRENCY:
        'https://prod-76.westus.logic.azure.com:443/workflows/d8c4b9c7d6ef48afa81b038798db1e45/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=MeJjGlxjw37934gmmFG8a27FJVK8KiuhEALPBDFKO2k',
      NOTIFICATIONS:
        'https://prod-150.westus.logic.azure.com:443/workflows/4ffc47ffd77244018a8c38e3693bdc8d/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=vUDn1TrcXsy9VEXw2C-nmk7m06YSHoP3wgG5C5uA6aI',
    },
  },
};
